import { usePage } from "@inertiajs/react"

import type { Category } from "@/lib/categories"
import { buildScreenshotCategoryColorById } from "@/lib/screenshot-category-colors"

interface SharedData {
  categories?: Category[]
  [key: string]: unknown
}

export function CategoryCssInjector() {
  const { categories = [] } = usePage<SharedData>().props

  if (!categories || categories.length === 0) {
    return null
  }

  const lightModeVars = categories
    .map((cat) => `--category-${cat.id}: ${cat.color};`)
    .join("\n    ")

  const darkModeVars = categories
    .map((cat) => `--category-${cat.id}: ${cat.color_dark};`)
    .join("\n    ")
  const screenshotColors = buildScreenshotCategoryColorById(categories)
  const screenshotModeVars = categories
    .map(
      (cat) =>
        `--category-${cat.id}: ${screenshotColors.get(cat.id) ?? cat.color};`,
    )
    .join("\n    ")

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `:root {
    ${lightModeVars}
}
.dark {
    ${darkModeVars}
}
.screenshot-preview {
    ${screenshotModeVars}
}
[data-screenshot-capturing="true"] {
    ${screenshotModeVars}
}`,
      }}
    />
  )
}
